export const API_INITIAL: number = 0
export const API_FETCHING: number = 100
export const API_SUCCESS: number = 200
export const API_PAGINATION_FINISHED: number = 300
export const API_FAILED: number = 400
export const API_SWIPE_REFRESH: number = 500
export const API_FETCHING_PAGINATION: number = 600

export const INIT: string = 'INIT'
export const LOAD_MORE: string = 'LOAD_MORE'

export type APIStatus = 0 | 100 | 200 | 300 | 400 | 500 | 600 | number
export type APIType = 'INIT' | 'LOAD_MORE' | string

export default {
   API_INITIAL,
   API_FETCHING,
   API_SUCCESS,
   API_PAGINATION_FINISHED,
   API_FAILED,
   API_SWIPE_REFRESH,
   API_FETCHING_PAGINATION,
   INIT,
   LOAD_MORE
}
